import { combineReducers } from 'redux'

import aiObjects from './aiObjects'
import aiObjectsWithStatistics from './aiObjectsWithStatistics'
import contentUniqueAIObjects from './contentUniqueAIObjects'
import attachAIModel from './attachAIModel'
import counterValuesList from './counterValuesList'
import deleteAiClass from './deleteAiClass'
import deleteNLPModel from './deleteNLPModel'
import deletePredictionSet from './deletePredictionSet'
import deleteVQAModel from './deleteVQAModel'
import editAIClassDialog from './editAIClassDialog'
import isAIObjectsLoading from './isAIObjectsLoading'
import isNLPModelsLoading from './isNLPModelsLoading'
import isPredictionSetsLoading from './isPredictionSetsLoading'
import isTenantConfigUpdating from './isTenantConfigUpdating'
import isUnattachedAIModelsLoading from './isUnattachedAIModelsLoading'
import isVQAModelsLoading from './isVQAModelsLoading'
import loadingCounters from './loadingCounters'
import nlpModels from './nlpModels'
import predictionSets from './predictionSets'
import selectedAIObject from './selectedAIObject'
import selectedUniqueAIObject from './selectedUniqueAIObject'
import selectedUniqueAIObjectAnnotation from './selectedUniqueAIObjectAnnotation'
import unattachedAIModels from './unattachedAIModels'
import uniqueAIObjects from './uniqueAIObjects'
import vqaModels from './vqaModels'
import conflictingAIObjects from './conflictingAIObjects'
import editUniqueAIObjectConnectionsDialog from './editUniqueAIObjectConnectionsDialog'

export default combineReducers({
  aiObjects,
  aiObjectsWithStatistics,
  attachAIModel,
  contentUniqueAIObjects,
  conflictingAIObjects,
  counterValuesList,
  deleteAiClass,
  deleteNLPModel,
  deletePredictionSet,
  deleteVQAModel,
  editAIClassDialog,
  editUniqueAIObjectConnectionsDialog,
  isAIObjectsLoading,
  isNLPModelsLoading,
  isPredictionSetsLoading,
  isTenantConfigUpdating,
  isUnattachedAIModelsLoading,
  isVQAModelsLoading,
  loadingCounters,
  nlpModels,
  predictionSets,
  selectedAIObject,
  selectedUniqueAIObject,
  selectedUniqueAIObjectAnnotation,
  unattachedAIModels,
  uniqueAIObjects,
  vqaModels,
})
